import React from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import './footer.scss'

const useStyles = makeStyles(() => ({
  footer: {
    position: 'relative',
    minHeight: 216,
    height: '100%',
    width: '100%',
    bottom: 0,
    backgroundImage: 'linear-gradient(to right, #023560 0px, #1e7ca9 100%)',
    borderTop: '2px solid #e6e6e6',
  },
  footerText: {
    fontWeight: '300',
    color: '#fff',
    margin: 'auto',
    paddingTop: '80px',
  },
  footerSubText: {
    fontWeight: '300',
    color: '#fff',
  },
  footerSubTextLink: {
    color: 'inherit',
    textDecoration: 'underline',
    '&:hover': {
      color: 'inherit',
      fontWeight: 'bold',
    },
    '&:visited': {
      color: '#BDBDBD',
    },
  },
}))

const linkUrl = 'https://scoir.helpdocs.io/article/odnas7ve8t-for-colleges-application-configuration'

export const Footer = () => {
  const classes = useStyles()

  return (
    <React.Fragment>
      <div className={classes.footer}>
        <Typography
          variant="h5"
          component="p"
          align="center"
          className={classes.footerText}
        >
          Questions about your Application Configuration?
        </Typography>
        <Typography
          variant="h6"
          component="p"
          align="center"
          className={classes.footerSubText}
        >
          Check out our easy&nbsp;
          <a
            id="footer-link"
            href={linkUrl}
            target="_blank"
            rel="noreferrer"
            className={classes.footerSubTextLink}
          >
            Help Doc
          </a>
          &nbsp;for all of your set up needs.
        </Typography>
      </div>
    </React.Fragment>
  )
}

export default Footer
